import { createProvider } from '@nvision/services/data-provider';

import * as api from './api';
import { normalizePalletLoadTypeList } from './normalize';

export const fetchPalletLoadTypeList = createProvider(api.fetchPalletLoadTypeList)
  .andThen((res) => normalizePalletLoadTypeList(res))
  .andCatch((error) => {
    if (error instanceof Error && error.name === 'AbortError') {
      console.warn('Fetch list aborted');
    } else {
      console.error('Fetch list was failed:', error);
    }
    throw error;
  });
